






  import { mixins } from 'vue-class-component';
  import { Component } from 'vue-property-decorator';
  import ScrollMixin from './scroll.mixin';

  /**
   * Base scroll component that depending on the user interactivity emits different events for
   * knowing when the user scrolls, the direction of scroll and if user reaches the start or end.
   *
   * @public
   */
  @Component
  export default class BaseScroll extends mixins(ScrollMixin) {}
